// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"0af9130f","911":"a707cebe"}[chunkId] + ".chunk.css";
};